

































import { Component, Vue, Prop } from "vue-property-decorator";
import { nodeData } from "./nodeData";



@Component
export default class agent_node extends Vue {
  @Prop({ required: true }) public node!: nodeData;
  @Prop({ default: false }) public selected!: boolean;

  @Prop({ default: false }) public linking!: boolean; // <-- NUEVO: indica si se está enlazando
  @Prop({ default: null }) public linkingTargetId!: string | null; // <-- NUEVO: id del nodo objetivo

  private dragging: boolean = false;
  private dragOffsetX: number = 0;
  private dragOffsetY: number = 0;
  private draggingPointerId: number = -1;
  private hoveringIn: boolean = false; // <-- NUEVO

  get styleObj() {
    return {
      left: this.node.x + "px",
      top: this.node.y + "px",
      width: this.node.w + "px",
      height: this.node.h + "px",
      cursor: this.dragging ? "grabbing" : "grab",
    };
  }

  // Método para calcular el ancho dinámico basado en el título
  private calculateDynamicWidth(): number {
    const minWidth = 120; // Ancho mínimo
    const maxWidth = 300; // Ancho máximo
    const baseWidth = 100; // Ancho base
    const charWidth = 8; // Aproximación del ancho por carácter
    
    const titleLength = this.node.title.length;
    const calculatedWidth = baseWidth + (titleLength * charWidth);
    
    return Math.max(minWidth, Math.min(maxWidth, calculatedWidth));
  }

  // === Drag del nodo con Pointer Events (fiable) ===
  public onPointerDown(e: PointerEvent) {
    // Si haces click en un puerto no empezamos drag del nodo
    const target = e.target as HTMLElement;
    if (target && target.classList.contains("port") || target.hasAttribute("data-delete")) {
      return;
    }

    const parent = (this.$el as HTMLElement).parentElement;
    if (!parent) {
      return;
    }
    const rect = parent.getBoundingClientRect();

    this.dragging = true;
    this.draggingPointerId = e.pointerId;
    this.dragOffsetX = e.clientX - rect.left - this.node.x;
    this.dragOffsetY = e.clientY - rect.top - this.node.y;

    const host = this.$el as any;
    if (host && host.setPointerCapture) {
      host.setPointerCapture(e.pointerId);
    }

    this.$emit("select", this.node.id);
    e.preventDefault();
  }

  public onPointerMove(e: PointerEvent) {
    if (!this.dragging || e.pointerId !== this.draggingPointerId) {
      return;
    }
    const parent = (this.$el as HTMLElement).parentElement;
    if (!parent) {
      return;
    }
    const rect = parent.getBoundingClientRect();
    const newX = e.clientX - rect.left - this.dragOffsetX;
    const newY = e.clientY - rect.top - this.dragOffsetY;
    this.$emit("drag", { id: this.node.id, x: newX, y: newY });
  }

  public onPointerUp(e: PointerEvent) {
    if (e.pointerId === this.draggingPointerId) {
      this.dragging = false;
      this.draggingPointerId = -1;
      const host = this.$el as any;
      if (host && host.releasePointerCapture) {
        try {
          host.releasePointerCapture(e.pointerId);
        } catch (err) {}
      }
    }
    // Selección por click
    this.$emit("select", this.node.id);
  }

  // Detecta si el mouse está sobre el puerto IN durante linking
  public onPortInEnter() {
    if (this.linking) {
      this.hoveringIn = true;
      this.$emit("hoverIn", this.node.id);
    }
  }
  public onPortInLeave() {
    if (this.linking) {
      this.hoveringIn = false;
      this.$emit("hoverOut", this.node.id);
    }
  }

  // === Linking (drag para crear conexión) ===
  public emitStartLink(e: PointerEvent) {
    const host = this.$el as HTMLElement;
    const parent = host.parentElement;
    if (!host || !parent) {
      return;
    }
    const parentRect = parent.getBoundingClientRect();
    const hostRect = host.getBoundingClientRect();

    // Origen en borde derecho-centro (OUT)
    const cx = hostRect.right - parentRect.left;
    const cy = hostRect.top - parentRect.top + hostRect.height / 2;
    this.$emit("startLink", this.node.id, { x: cx, y: cy });
  }

  public emitFinishLink() {
    // Finalizar en puerto IN del nodo
    this.$emit("finishLink", this.node.id);
  }
  public emitDelete() {
    console.log("Emit delete for node:", this.node.id);
    this.$emit("delete", this.node.id);
  }
}
